import { useState } from "react";
//import {useTranslation} from "react-i18next";
//import {getUser} from "@/utils/User";

import {
    MenuItem,
    MenuList,
    Button,
    Divider,
    ListItemIcon,
    ListItemText,
    Typography,
    Avatar,
    Stack
} from '@mui/material';

import {
    AccountPreview,
    SignOutButton,
    AccountPopoverFooter,
} from '@toolpad/core/Account';

import AddIcon from '@mui/icons-material/Add';
import { useSession } from '@toolpad/core/useSession';
import { saveUser } from "@/utils/User";

export function LoginMenu({darkmode}){

    const session = useSession();
    const [ user ] = useState(session?.user);
    const [ companies ] = useState(user?.companies);

    const handleCompany = (e, companyId) => {  

        // change user company
        user.company = companyId;
        saveUser(user);

        session?.setUser(user);

        window.location.reload(); // reload page to send the new database to the backend
    };
  
    return (
        <Stack 
            sx={{                
                maxHeight:'84vh',
                border: darkmode ? '1px solid rgb(255,255,255,0.5)' : null,
                borderRadius: '5px'             
            }} 
            direction="column"
        >
            <AccountPreview variant="expanded"/>
            <AccountPopoverFooter>
                <SignOutButton/>
            </AccountPopoverFooter>
            <Divider/>
            <Typography variant="body2" mx={2} mt={1} align={'center'} sx={{fontWeight:'bold'}}>
                {session?.t('company.title')}
            </Typography>            
            <MenuList                 
                sx={{
                    paddingX: '2px',                    
                    paddingBottom: '1px',
                    overflowY: 'auto',                    
                }}
            >
                {
                    companies && Object?.keys(companies)?.length > 0 && Object?.keys(companies)?.map((companyId) => {

                        companyId = parseInt(companyId);
                        var userCompany = parseInt(user?.company);

                        return (
                            <MenuItem
                                key={'company_'+companyId}
                                component="button"
                                sx={{
                                    justifyContent: 'flex-start',
                                    width: '100%',
                                    columnGap: 2,
                                    border: darkmode ? '1px solid rgb(255,255,255,0.5)' : '1px solid rgb(129,0,0,0.2)',
                                    borderRadius: '5px',
                                    marginY: '2px',
                                    backgroundColor: companyId === userCompany ? darkmode ? 'rgb(255,255,255,0.3)' : 'rgb(129,0,0,0.2)' : '',
                                }}
                                onClick={(e) => companyId === userCompany ? null : handleCompany(e,companyId)}
                            >
                                <div className='overflow-x-auto flex items-center'>
                                    <div>
                                        <ListItemIcon>
                                            <Avatar
                                                sx={{
                                                    width: 32,
                                                    height: 32,
                                                    fontSize: '0.95rem',
                                                    bgcolor: '#810000',
                                                }}
                                                //src={item.image ?? ''}
                                                alt={companies[companyId]?.name ?? ''}
                                            >
                                                {companies[companyId]?.name[0]}
                                            </Avatar>
                                        </ListItemIcon>
                                    </div>
                                    <div className='w-full ml-1'>
                                        <ListItemText
                                            sx={{
                                                //display: 'flex',
                                                //flexDirection: 'column',
                                                //alignItems: 'flex-start',
                                                //width: '100%'                                
                                            }}
                                            primary={companies[companyId]?.name}
                                            //secondary={item.email}
                                            primaryTypographyProps={{ variant: 'body2' }}
                                            //secondaryTypographyProps={{ variant: 'caption' }}
                                        />
                                    </div>
                                </div>
                            </MenuItem>
                        );
                    })
                }                
            </MenuList>        
        </Stack>
    );
}
